import { PROFILE_CONFIG } from "../../config/profile.config";
import { ProximityDialog } from "../ui/ProximityDialog";

export function createContactDialog(): ProximityDialog {
  const { email, linkedin, github } = PROFILE_CONFIG.contact;
  const yearsOfExperience = new Date().getFullYear() - 2019;
  const bodyHtml = `
      <p style="margin:0 0 16px;">Hey there! I am Lasantha Sanjeewa, a Senior Software & DevOps Engineer with over ${yearsOfExperience} years of industry experience. Great to meet you. Feel free to explore my work, and you can find my contact info below.</p>
      <p style="margin:0 0 8px;">
        <b style="color:#fff;">Email:</b>
        <a href="${email.href}" style="color:rgba(255,180,80,0.9);text-decoration:none;">${email.display}</a>
      </p>
      <p style="margin:0 0 8px;">
        <b style="color:#fff;">LinkedIn:</b>
        <a href="${linkedin.href}" target="_blank" rel="noopener noreferrer" style="color:rgba(255,180,80,0.9);text-decoration:none;">${linkedin.display}</a>
      </p>
      <p style="margin:0;">
        <b style="color:#fff;">GitHub:</b>
        <a href="${github.href}" target="_blank" rel="noopener noreferrer" style="color:rgba(255,180,80,0.9);text-decoration:none;">${github.display}</a>
      </p>
    `;
  return new ProximityDialog({
    title: "Let's Connect!",
    bodyHtml,
    closeKey: "e",
    closeBtnLabel: "Close  [E]",
  });
}

export function createInProgressDialog(): ProximityDialog {
  const bodyHtml = `
      <p style="margin:0 0 14px;">
        This island is still very much a <b style="color:rgba(255,180,80,0.9);">work in progress</b>.
        What you're exploring right now is an early version things may be rough around the edges,
        a few corners may be suspiciously empty, and at least one thing is probably broken.
      </p>
      <p style="margin:0 0 14px;">
        More content, polish, and probably a swimming animation <i>(no promises)</i> are on the way.
        I'll keep chipping away at it in between, you know, actual work.
      </p>
      <p style="margin:0;font-size:13px;color:rgba(255,255,255,0.4);font-style:italic;">
        Thanks for visiting anyway, it means a lot. 👀
      </p>
    `;
  return new ProximityDialog({
    title: "🚧 Work in Progress",
    bodyHtml,
    closeKey: "e",
    closeBtnLabel: "Got it  [E]",
  });
}

export function createSkillStoneDialog(): ProximityDialog {
  const row = (label: string, value: string) => `
      <div style="margin:0 0 12px;">
        <div style="color:rgba(255,180,80,0.9);font-weight:600;margin-bottom:2px;">${label}</div>
        <div style="color:rgba(255,255,255,0.8);">${value}</div>
      </div>`;

  const yearsOfExperience = new Date().getFullYear() - 2019;
  const bodyHtml = `
      <div style="text-align:left;">
        ${row("🗓️ Experience", `${yearsOfExperience}+ years of industry experience`)}
        ${row("💻 Languages", "PHP, Python, JavaScript, Terraform, OpenTofu")}
        ${row("🚀 Frameworks", "Laravel, React, Vue, Next.js, Nuxt.js, Node.js")}
        ${row("🛠️ Tools", "Docker, MySQL, MariaDB, AWS, OpenClaw, Claude, Co-Pilot, Github Actions, Bitbucket")}
        ${row("🎮 Hobbyist", "Babylon.js, Blender, C# &amp; Unity 3D")}
      </div>
    `;
  return new ProximityDialog({
    title: "Skills & Technologies",
    bodyHtml,
    closeKey: "e",
    closeBtnLabel: "Close  [E]",
  });
}

export function createBoatDialog(): ProximityDialog {
  const bodyHtml = `
      <p style="margin:0 0 14px;font-size:22px;">⛵ Ahoy there, Captain!</p>
      <p style="margin:0 0 12px;">
        Thinking about sailing away? Bold move.
        Too bad this boat is purely decorative. It's basically a very
        expensive piece of driftwood at this point.
      </p>
      <p style="margin:0 0 12px;">
        <b style="color:rgba(255,180,80,0.9);">The good news?</b> You can totally jump into the sea.
        Just… don't expect a breaststroke. The moment you hit the water
        you'll respawn back at the start. Think of it as a very aggressive teleport.
      </p>
      <p style="margin:0 0 12px;">
        <b style="color:rgba(255,180,80,0.9);">The bad news?</b> There's no swimming animation.
        I ran out of time. So you'll just sink and respawn.
      </p>
      <p style="margin:0;font-size:13px;color:rgba(255,255,255,0.4);font-style:italic;">
        🏊 Swimming: coming soon™ maybe. Depends entirely on how my free time feels about it.
      </p>
    `;
  return new ProximityDialog({
    title: "Leaving Already? 🚢",
    bodyHtml,
    closeKey: "e",
    closeBtnLabel: "Stay on the island  [E]",
  });
}

export function createWorkspaceDialog(): ProximityDialog {
  const { title, bio } = PROFILE_CONFIG;
  const bodyHtml = `
      <p style="margin:0 0 6px;font-size:13px;text-transform:uppercase;letter-spacing:1.5px;color:rgba(255,180,80,0.8);font-weight:600;">${title}</p>
      <p style="margin:0 0 14px;">${bio[0]}</p>
      <p style="margin:0 0 16px;">${bio[1]}</p>
      <p style="margin:0;">${bio[2]}</p>
    `;
  return new ProximityDialog({
    title: "Workspace",
    bodyHtml,
    closeKey: "e",
    closeBtnLabel: "Close  [E]",
  });
}
